import { environment } from '../../environments/environment';
import { isClassicGapHost } from './brand';

function resolveFormBase(): string {
  // Real GAP host: same origin. Prerender/localhost has no public hostname —
  // fall back to environment.formBaseUrl (gap_* SSG configs).
  const hostname = typeof location !== 'undefined' ? location.hostname : '';
  if (hostname.includes('gaponline') && isClassicGapHost(hostname)) {
    return location.origin.replace(/\/$/, '');
  }

  return (environment.formBaseUrl ?? environment.baseUrl).replace(/\/$/, '');
}

/** Absolute URL for GAP form paths (LP cross-host or same-origin on full SPA). */
export function gapFormUrl(path: string, fragment?: string): string {
  const base = resolveFormBase();
  const normalized = path.startsWith('/') ? path : `/${path}`;
  const url = `${base}${normalized}`;
  return fragment ? `${url}#${fragment}` : url;
}
